export default "__VITE_ASSET__Dva_II6s__"